<template>
  <div>

      <v-card>
          <v-col>
            <!-- ALERTA / RESUMEN DE DEUDA SAP -->
            <v-alert
              v-if="debtInfo"
              :type="hasDebt ? 'error' : 'info'"
              outlined
              dense
              class="mb-3"
            >
              <div class="d-flex justify-space-between align-center flex-wrap">
                <div>
                  <strong>Deuda Total:</strong> S/ {{ debtInfo.TotalGlobalDebtPEN ? debtInfo.TotalGlobalDebtPEN.toFixed(2) : "0.00" }}
                </div>
                <v-chip v-if="hasDebt" color="error" small class="ml-2">
                  No se permite cambiar de cobrador por deuda pendiente
                </v-chip>
              </div>
            </v-alert>

            <s-crud
              no-border
              formPermanent noEdit
              title="Responsables por Cob"
              :config="configCrud"
              :filter="filter"
              @save="save($event)"
              height="200"
              close
              @close="close()"
            >
              <template slot-scope="props">
                <v-container v-if="props.item != null" class="pb-0">
                  <v-row justify="center">
                    <template>
                      <v-col
                        cols="12"
                        class="pt-0 pr-0 pl-0 pb-0"
                        sm="11"
                        md="11"
                        lg="11"
                      >
                        <v-alert
                          border="left"
                          shaped
                          colored-border
                          type="warning"
                          elevation="1"
                          dismissible
                        >
                          Los Responsables por cobrar deben ser registrados con
                          su respectivo número de RUC.
                        </v-alert>
                      </v-col>                     
                    </template>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" class="s-col-form" sm="6">
                      <s-select-producer-rc 
                        v-model="props.item.PrdID"
                        label="Productor Asociado" 
                        @changeProd="changeProducer($event)"
                      />
                    </v-col>
                    <v-col cols="6" class="s-col-form" sm="6">
                      <s-text
                        v-model="dataProd.PrdCardCode"
                        label="Codigo Prod."
                        disabled
                      >
                      </s-text>
                    </v-col>
                    <v-col cols="6" class="s-col-form" sm="6">
                      <s-text
                        v-model="dataProd.PrdCardName"
                        label="Nombre del Responsable por cobrar"
                        disabled
                      >
                      </s-text>
                    </v-col>
                    <v-col cols="6" class="s-col-form" sm="6">
                      <s-select-definition
                        v-model="dataProd.TypeSupplier"
                        label="Tipo Proveedor"
                        :def="1160"
                        readonly
							        ></s-select-definition>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                  </v-row>
                </v-container>
              </template>
              <template v-slot:FrcStatus="{ row }">                
                <v-icon :color="row.FrcStatus == 1 ? 'success' : 'default'">
                  mdi-checkbox-blank-circle</v-icon>
              </template>
            </s-crud>
          </v-col>
      </v-card>
  </div>
</template>

<script>
import SSelectProducerRc from "../../../components/HarvestSchedule/SSelectProducerRc.vue";
import sToolbarPerson from "../..//TecnicalAssistence/ProducersFarms/sToolbarPerson";
import sSelectWorker from "@/components/Utils/Worker/sSelectWorker";
import _sResponsibleCollecting from "@/services/Technicalassistance/TasAgriculturalFarmResponsibleCollecting/TasAgriculturalFarmResponsibleCollectingService";
import _sAdvanceProducerService from "@/services/Technicalassistance/AdvanceProducerService";
 
export default {
  name: "sAgriculturalFarmResponsibleCollecting",
  components: { 
      sToolbarPerson
    , sSelectWorker
    , SSelectProducerRc 
  },
  props: {  
    FltID: { type: Number, default: 0 },
    PrsID: { type: Number, default: 0 },
    PrdID: { type: Number, default: 0 },
  },

  data() {
    return {
      dataProd: {},
      filter: { }, 
      debtInfo: null,
      loadingDebt: false,
      item: {
        PrdStatus: 1,
        PrsDocumentNumber: "",
        tipoProveedor: "",
        tipoproductor: "", 
      },
    };
  },
  computed: {
    hasDebt() {
      if (!this.debtInfo) return false;
      return (this.debtInfo.TotalGlobalDebtPEN || 0) > 0;
    },
    configCrud() {
      return {
        model: {
          FrcDateEnd: "datetime",
          FrcDateBegin: "datetime",
          FrcID: "ID",
          PrdID: "int",
          FltID: "int",
          PrsID: "int",
          NtpID: "int",
          JrpID: "int",
          PrdCardCode: "string",
          PrdCardName: "string",
          PrsDocumentNumber: "string",
          PrdStatus: "int",
          PrdIDText: "string",
          FrcStatus: "int",
        }, 
        service: _sResponsibleCollecting,
        headers: this.$fun.getSecurity().IsLevelAdmin
          ? [
              { text: "#", value: "FrcID", sortable: false },
              { text: "Nombre del Responsable", value: "FullName", sortable: false, width: 300, },
              { text: "Documento", value: "PrsDocumentNumber", sortable: false, width: 100,align:"center"},
              { text: "Tipo de Proveedor", value: "TypeSupplierText", width: 30 },
              { text: "Fecha Inicio", value: "FrcDateBegin", sortable: false },
              { text: "Fecha Fin", value: "FrcDateEnd", sortable: false },
              { text: "Estado", value: "FrcStatus", sortable: false ,align:"center" },
            ]
          : [
              { text: "ID", value: "FrcID", sortable: false },
              { text: "Nombre del Responsable", value: "FullName", sortable: false, width: 300, },
              { text: "Documento", value: "PrsDocumentNumber", sortable: false, width: 100,align:"center" },
              { text: "Tipo de Proveedor", value: "TypeSupplierText", width: 30 },
              { text: "Fecha Inicio", value: "FrcDateBegin", sortable: false },
              { text: "Fecha Fin", value: "FrcDateEnd", sortable: false },
              { text: "Estado", value: "FrcStatus", sortable: false,align:"center" },
            ],
      };
    },
    isAdmin() {
      this.$fun.getSecurity().IsLevelAdmin;
      console.log(this.$fun.getSecurity().IsLevelAdmin);
    },
  },
  methods: {
    fetchProducerTotalDebt() {
      if (!this.PrdID || this.PrdID <= 0) {
        this.debtInfo = null;
        return;
      }
      this.loadingDebt = true;
      _sAdvanceProducerService
        .ProducerTotalDebtSAP(this.PrdID, this.$fun.getUserID())
        .then((res) => {
          this.debtInfo = res.data || res;
        })
        .catch((err) => {
          console.error("Error al consultar ProducerTotalDebtSAP:", err);
          this.debtInfo = null;
        })
        .finally(() => {
          this.loadingDebt = false;
        });
    },
    changeProducer(data){
      this.dataProd = data;
      console.log("data", data);
    },
    clear(item)
    {
      this.FrcDateEnd = "";
    },
    inputbegin(val,v){
     
    },
    Initialize() {
      this.filter = { FltID: this.FltID };
      this.fetchProducerTotalDebt();
    },
    edit(item) {
      console.log("Editar", this.producer);
      console.log(item);
    },
    close(){
      this.$emit("close");
    },
    rowSelected(rows) {
      console.log("Seleccion", rows);
    },
    hadReturnPerson(value, item) {
      if (value != null) {
        item.PrdCardName = value.PrdCardName;
        item.PrdCardCode = value.PrdCardCode;
        item.PrsDocumentNumber = value.PrsDocumentNumber;
        item.FullName = value.PrdCardName;
        this.PrsID = value.PrsID;
      }
    },
    
    save(item) {
      if (this.hasDebt) {
        this.$fun.alert(
          `No se puede cambiar o agregar responsable por cobrar porque el productor registra una deuda global pendiente de S/ ${this.debtInfo.TotalGlobalDebtPEN.toFixed(2)}.`,
          "error"
        );
        return;
      }

      item.FltID = this.FltID;
      item.FrcDateEnd = this.FrcDateEnd; 
      item.PrsID = this.dataProd.PrsID;
      item.PrdCardName = this.dataProd.PrdCardName;
      item.TypeSupplier = this.dataProd.TypeSupplier; 

      console.log(item);

      if (!(item.PrsID > 0)) {
        this.$fun.alert(
          "Registre el documento de la Persona, seleccionando el signo (+)",
          "warning"
        );
        return;
      }
      if (item.PrdCardName.length == 0) {
        this.$fun.alert("Registre el Nombre del Productor", "warning");
        return;
      }

      console.log('data send: ', item);
      item.save();
    },
    prgReturnPerson(value) {
      if (value != null) {
        this.item.FullName = value.FullName;
      }
    },
  },
  watch: {
    agriculturalFarmID() {
      this.Initialize();
    },
    FltID() {
      this.Initialize();
    },
    PrdID() {
      this.fetchProducerTotalDebt();
    },
  },
  created() {
    this.Initialize();
  },
};
</script>
